@if (!opened) {
<mat-toolbar color="primary" class="buttons">
  @if (!(['xs', 'sm', 'md'] | breakpoint | async)) {
  <button mat-button (click)="onGoHome()">
    {{ "Home" | translate }}
  </button>
  <div class="right-menu">
    <!-- <app-archive></app-archive> -->
    <app-standings></app-standings>
    <app-races></app-races>
    @if (!loggedIn) {
    <button mat-button (click)="openLoginDialog()" [disabled]="loggedIn">
      <mat-icon>login</mat-icon>
      {{ "Login" | translate }}
    </button>
    <button mat-button (click)="openDialog()">
      <mat-icon>person_add</mat-icon>
      {{ "Registration" | translate }}
    </button>
    } @else {
    <app-profile-info></app-profile-info>
    } @if (!(['xs', 'sm', 'md'] | breakpoint | async)) {
    <app-language-switcher></app-language-switcher>
    }
  </div>
  } @else {
  <button mat-icon-button (click)="handleSideNav()">
    <mat-icon>menu</mat-icon>
  </button>
  @if (!loggedIn) {
  <button mat-button (click)="openLoginDialog()" [disabled]="loggedIn">
    <mat-icon>login</mat-icon>
    {{ "Login" | translate }}
  </button>
  } @else {
  <app-profile-info></app-profile-info>
  } }
</mat-toolbar>
}
<mat-sidenav-container>
  <mat-sidenav [opened]="opened" mode="side" class="side-nav">
    <div class="close-icon">
      <app-language-switcher></app-language-switcher>
      <button mat-icon-button (click)="handleSideNav()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-nav-list>
      <a mat-list-item>
        <div class="list-item normal" (click)="onGoHome()">
          <mat-icon> home </mat-icon>
          {{ "Home" | translate }}
        </div>
      </a>
      <!-- <app-archive (onCloseSideNav)="closeSideNav()"></app-archive> -->
      <app-standings></app-standings>
      <app-races></app-races>
      @if (loggedIn) {
      <app-profile-info
        [sideNavMode]="true"
        (onCloseSideNav)="closeSideNav()"
      ></app-profile-info>
      } @else {
      <a mat-list-item>
        <div class="list-item normal" (click)="openLoginDialog()">
          <mat-icon> login </mat-icon>
          {{ "Login" | translate }}
        </div>
      </a>
      <a mat-list-item>
        <div class="list-item normal" (click)="openDialog()">
          <mat-icon> person_add </mat-icon>
          {{ "Registration" | translate }}
        </div>
      </a>
      }
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content class="content">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
